module.exports = __webpack_public_path__ + "static/media/alertaROJA_TIEMPO.2bfcd14f.svg";